export default __webpack_public_path__ + "static/media/f3.ab69888a.png";